import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.0039 2.00195L13.0018 3.08326C15.8386 3.56007 18 6.02763 18 9L22 9V22H20V17.5C20 15.567 18.433 14 16.5 14C14.567 14 13 15.567 13 17.5V22H11V17.5C11 15.567 9.433 14 7.5 14C5.567 14 4 15.567 4 17.5V22H2V9L6 9C6 6.02638 8.1632 3.558 11.0018 3.08266L11.0039 1.99805L13.0039 2.00195ZM10.998 5.99805V8.00195H13.002V5.99805H10.998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 16C6.67157 16 6 16.6716 6 17.5V22H9V17.5C9 16.6716 8.32843 16 7.5 16Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5 16C15.6716 16 15 16.6716 15 17.5V22H18V17.5C18 16.6716 17.3284 16 16.5 16Z"}}]};

const Palace1Filled = Vue.extend<IconProps>({
  name: 'Palace1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'palace-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Palace1Filled;
